<template>
  <div id="vessel-basic-info-view" v-if="vessel">
    <vx-card title="" class="mb-base">
      <div class="vx-row">
        <div class="vx-col" id="vessel-img-col">
          <div class="img-container mb-4">
            <img :src="photoUrl" class="rounded w-full" />
            <p>{{ photoText }}</p>
          </div>
        </div>
        <div class="vx-col flex-1" id="vessel-info-col-1">
          <vs-collapse>
            <vs-collapse-item
              icon-pack="feather"
              icon-arrow="icon-chevrons-down"
            >
              <div slot="header">
                <ul class="vessel-category">
                  <li class="vessel-nationality-column">
                    {{ $t("Views.Vessel.Country") }}
                  </li>
                  <li class="vessel-nationality-flag">
                    <div class="mt-2 img-flag--container">
                      <img :src="countryFlag" class="rounded" border="1" />
                    </div>
                  </li>
                  <li class="vessel-category-column">
                    {{ $t("Views.Vessel.Category") }}
                  </li>
                  <li class="vessel-category-column-text">
                    {{
                      getVesselCategoryProps(vessel.vessel_category.id).name_ja
                    }}
                  </li>
                </ul>
              </div>
              <!-- 1列目 -->
              <vs-row vs-w="12" vs-justify="space-between">
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="6"
                  vs-xs="12"
                >
                  <span class="vessel-info-column">
                    {{ $t("Views.Vessel.IMO") }}
                  </span>
                  <span class="vessel-info-text">
                    {{ vessel.imo || "---" }}
                  </span>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="6"
                  vs-xs="12"
                >
                  <span class="vessel-info-column">
                    {{ $t("Views.Vessel.CallSign") }}
                  </span>
                  <span class="vessel-info-text">
                    {{ vessel.call_sign || "---" }}
                  </span>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="6"
                  vs-xs="12"
                >
                  <span class="vessel-info-column">
                    {{ $t("Views.Vessel.MMSI") }}
                  </span>
                  <span class="vessel-info-text">
                    {{ vessel.mmsi || "---" }}
                  </span>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="6"
                  vs-xs="12"
                >
                  <span class="vessel-info-column">
                    {{ $t("Views.Vessel.CertificateNumber") }}
                  </span>
                  <span class="vessel-info-text">
                    {{ vessel.certificate_number || "---" }}
                  </span>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="6"
                  vs-xs="12"
                >
                  <span class="vessel-info-column">
                    {{ $t("Views.Vessel.IdentificationNumber") }}
                  </span>
                  <span class="vessel-info-text">
                    {{ vessel.identification_number || "---" }}
                  </span>
                </vs-col>
              </vs-row>
              <!-- 2列目 -->
              <vs-row vs-w="12" vs-justify="space-between" class="mt-2">
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="6"
                  vs-xs="12"
                >
                  <span class="vessel-info-column">
                    {{ $t("Views.Vessel.LengthOverall") }}
                  </span>
                  <span class="vessel-info-text">
                    {{ vessel.vessel_size.length_overall || "---" }} m
                  </span>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="6"
                  vs-xs="12"
                >
                  <span class="vessel-info-column">
                    {{ $t("Views.Vessel.Width") }}
                  </span>
                  <span class="vessel-info-text">
                    {{ vessel.vessel_size.width || "---" }} m
                  </span>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="6"
                  vs-xs="12"
                >
                  <span class="vessel-info-column">
                    {{ $t("Views.Vessel.FullDraft") }}
                  </span>
                  <span class="vessel-info-text">
                    {{ vessel.vessel_size.full_draft || "---" }} m
                  </span>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="6"
                  vs-xs="12"
                >
                  <span class="vessel-info-column">
                    {{ $t("Views.Vessel.GrossTonnage") }}
                  </span>
                  <span class="vessel-info-text">
                    {{ vessel.vessel_size.gt || "---" }} t
                  </span>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="6"
                  vs-xs="12"
                >
                </vs-col>
              </vs-row>
              <!-- 写真 -->
              <div class="vessel-pictures-container">
                <div class="vx-row">
                  <div
                    v-for="(img) in pictures"
                    :key="img.id"
                    class="vx-col w-full lg:w-1/6 sm:w-1/4 mb-base"
                  >
                    <vx-card class="overlay-card overflow-hidden">
                      <template slot="no-body">
                        <img :src="img" class="responsive vessel-pictures" />
                      </template>
                    </vx-card>
                  </div>
                </div>
              </div>
              <!-- ボタン -->
              <div class="vx-col w-full flex">
                <vs-button
                  v-show="activeDisableBtn"
                  class="mr-4"
                  @click="confirmDisableVessel"
                  type="border"
                  color="danger"
                  >運航停止</vs-button
                >
                <vs-button
                  v-show="activeEnableBtn"
                  class="mr-4"
                  @click="confirmEnableVessel"
                  type="border"
                  >運航再開</vs-button
                >
                <vs-button
                  :to="{
                    name: 'enterprise-management-vessel-edit',
                    params: { vesselId: $route.params.vesselId }
                  }"
                  class="mr-4"
                  >編集</vs-button
                >
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import { VesselMixin } from "@/mixins";
import "swiper/dist/css/swiper.min.css";
import { createNamespacedHelpers } from "vuex";

// Store
const {
  mapActions: mapActionsOfVesselView,
  mapState: mapStateOfLiveVesselView,
  mapGetters: mapGettersOfVesselView
} = createNamespacedHelpers("enterpriseVesselView");

export default {
  mixins: [VesselMixin],
  data() {
    return {
      photoUrl: require("@/assets/images/no_image_bg.svg"),
      photoText: "取得中",
      swiperOptionTop: {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true
      },
      slides: [],
      pictures: []
    };
  },

  watch: {
    vesselPictures() {
      this.setPictures();
    }
  },

  computed: {
    ...mapStateOfLiveVesselView({
      vessel: state => state.vessel,
      vesselPictures: state => state.vesselPictures,
      countryCodes: state => state.countryCodes
    }),

    ...mapGettersOfVesselView(["getCountryAlpha2"]),

    isEdit() {
      return this.vessel.permission_level === this.permissionLevel.EDIT;
    },

    activeDisableBtn() {
      return (
        this.vessel.permission_level === this.permissionLevel.EDIT &&
        this.vessel.disabled_at === null
      );
    },

    activeEnableBtn() {
      return (
        this.vessel.permission_level === this.permissionLevel.EDIT &&
        this.vessel.disabled_at !== null
      );
    },

    countryFlag() {
      if (!this.countryCodes) return;
      let countryAlpha2 = this.getCountryAlpha2(this.vessel.country_code.id);
      return countryAlpha2 ? require(`@/assets/images/flags/${countryAlpha2}.svg`) : null;
    }
  },
  methods: {
    ...mapActionsOfVesselView([
      "fetchVesselGeneralInfo",
      "disableVessel",
      "enableVessel"
    ]),

    async setPictures() {
      if (this.vesselPictures.length !== 0) {
        for (const picture of this.vesselPictures) {
          let url = await storage
            .child(picture.picture.thumbnail_path)
            .getDownloadURL();
          this.pictures.push(url);
        }
        this.photoUrl = this.pictures[0];
        this.photoText = "";
      } else {
        this.photoText = "No image";
      }
    },

    confirmEnableVessel() {
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: `運航再開`,
        text: `${this.vessel.name_ja}のステータスを運航再開にしますか？`,
        accept: this.onEnableVessel,
        acceptText: "再開する",
        cancelText: "キャンセル"
      });
    },

    onEnableVessel() {
      this.enableVessel(this.$route.params.vesselId);
    },

    confirmDisableVessel() {
      let vesselName =
        this.vessel.name_ja !== null ? this.vessel.name_ja : this.vessel.name;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `運航停止`,
        text: `${vesselName}のステータスを運航停止にしますか？`,
        accept: this.onDisableVessel,
        acceptText: "停止する",
        cancelText: "キャンセル"
      });
    },

    onDisableVessel() {
      this.disableVessel(this.$route.params.vesselId);
    }
  },
  created() {
    this.fetchVesselGeneralInfo(this.$route.params.vesselId);
  }
};
</script>

<style lang="scss">

#vessel-basic-info-view {
  #vessel-img-col {
    width: 10rem;
    .img-container {
      position: relative;
    }
    .img-container p {
      position: absolute;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      margin: 0;
      padding: 0;
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
      line-height: 26px;
      color: #ffffff;
    }
    .img-container img {
      width: 112px;
      height: 112px;
      object-fit: cover;
    }
  }
  #vessel-info-col-1 {
    padding-top: 40px;
    padding-left: 0px;
    .vs-collapse {
      padding: 0px !important;
    }
    .vessel-name li {
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 26px;
      color: #333333;
      display: inline-block;
    }
    .vessel-category {
      li {
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 25px;
        color: #828282;
        display: inline-block;
        vertical-align: top;
        .img-flag--container {
          margin-left: 20px;
          margin-right: 20px;
          img {
            border: 1px #e2e2e2 solid;
          }
          width: 44px;
          height: 44px;
        }
      }
      .vessel-nationality-column {
        margin-top: 10px;
      }
      .vessel-category-column {
        margin-top: 10px;
        margin-left: 20px;
        margin-right: 20px;
      }
      .vessel-category-column-text {
        margin-top: 12px;
        font-style: normal;
        font-weight: normal;
        line-height: 25px;
        font-size: 16px;
        line-height: 20px;
        color: #333333;
      }
    }
    .vessel-name-jp {
    }
    .vessel-name-eg {
      padding-left: 25px;
    }
    .vessel-info-column {
      font-style: normal;
      font-weight: normal;
      line-height: 25px;
      font-size: 15px;
      color: #828282;
      padding-right: 6px;
    }
    .vessel-info-text {
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      color: #333333;
    }
  }
  .vessel-pictures-container {
    margin-top: 20px;
    margin-bottom: 10px;
    .vessel-pictures {
      object-fit: cover;
    }
  }
}
</style>
